import { TecLoader } from "./TechLoader";
import { TecItemCreateTop } from "./TecItemCreateTop";
import { TweenMax } from "gsap";
import CarouselMv from "../utils/CarouselMv";
import Carousel from "../utils/carousel";

/**
 * [PointOfViewに表示する技業log]
 *
 * @export
 * @class TecTop
 */
export class TecTop {
  private target;
  private main;

  constructor( target ) {
    this.target = target;
    this.main = this.target.find('.carousel ul')
    this.target.empty();
    new TecLoader( (data)=> { this.onData(data) } );
  }

  /**
   * データ取得完了。オブジェクト作成
   * @param {*} data
   * @memberof TechIndex
   */
  public onData(data):void {
    let i:number;
    let mv_src:string = '';
    // 表示要素生成
    var src:TecItemCreateTop = new TecItemCreateTop();
    var src_create = src.createItem(data);
    var src_create_mv = src_create.src_data;
    let li = '';
    for(i = 0; i < 3; i++) {
      let mv = src_create_mv[i];
      li +=mv;
    }
    this.target.append( li );


    // this.main.append( mv_src );
    


    // new Carousel( this.main );
  }
}